import React from "react";

import ourStoryMobile from "assets/images/our-story-mobile.jpg";
import ourStoryMobileWebp from "assets/images/our-story-mobile.jpg?as=webp";
import readingGirl from "assets/images/reading-girl.jpg";
import readingGirlWebp from "assets/images/reading-girl.jpg?as=webp";
import readingGirlPlaceholder from "assets/images/reading-girl-placeholder.jpg";
import readingGirlPlaceholderWebp from "assets/images/reading-girl-placeholder.jpg?as=webp";
import LazyLoad from "react-lazyload";
import { checkWebPSupport } from "supports-webp-sync";
import loadable from "@loadable/component";
import { useProgressiveImage } from "../../hooks";

const FadeIn = loadable(() => import("../common/FadeIn"));

const HeroBackgroundImage = () => {
  const isWebPSupport = checkWebPSupport();
  const placeholder = isWebPSupport
    ? readingGirlPlaceholderWebp
    : readingGirlPlaceholder;
  const loaded = useProgressiveImage(
    isWebPSupport ? readingGirlWebp : readingGirl
  );

  return (
    <section
      className="hero hero--background-image"
      style={{ backgroundImage: `url(${loaded || placeholder})` }}
    >
      <figure className="hero__mobile-image">
        <LazyLoad>
          <FadeIn>
            <picture>
              <source srcSet={ourStoryMobileWebp} type="image/webp" />
              <source srcSet={ourStoryMobile} type="image/jpg" />
              <img src={ourStoryMobile} alt="Our Story" />
            </picture>
          </FadeIn>
        </LazyLoad>
      </figure>
      <div className="container">
        <h1 className="hero__title">
          Because Every Family Deserves Cleaner Air
        </h1>
        <div className="emoji-line">
          <p>👨</p>
          <p>👨</p>
          <p>👨</p>
        </div>
        <h2 className="hero__highlighted-text">
        Why We Built Mila – The Air Purifier Made for Families
        </h2>
        <div className="hero__content">
          <p>
            As fathers living in Shanghai, our founders Grant, Dave, and Charles
            got up close and personal with the impacts of urban air pollution.
            Between nasty chronic coughs and weekends cooped up indoors, we saw
            firsthand how the smog affected both the physical and mental
            wellbeing of our families—and decided to do something about it.
          </p>
          <p>We set out to create the best air purifier on the market.</p>
        </div>
      </div>
    </section>
  );
};

export default HeroBackgroundImage;
